"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Tab_1 = __importDefault(require("./Tab"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var TableHeader = function (_a) {
    var _b;
    var onClickHandler = _a.onClickHandler, activeTab = _a.activeTab;
    var t = (0, next_intl_1.useTranslations)('lottery');
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var tabs = (0, react_1.useMemo)(function () {
        if (isAuth)
            return [
                { slug: 'prizes', index: 0 },
                { slug: 'rules', index: 1 },
                { slug: 'ticketsHistory', index: 2 },
            ];
        return [
            { slug: 'prizes', index: 0 },
            { slug: 'rules', index: 1 },
        ];
    }, [isAuth]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t((_b = tabs.find(function (t) { return t.index === activeTab; })) === null || _b === void 0 ? void 0 : _b.slug)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.tabs }, tabs.map(function (tab, idx) { return (react_1.default.createElement(Tab_1.default, { key: tab.slug + idx, tab: tab, onClickHandler: function () { return onClickHandler(tab.index); }, isActiveTab: activeTab === idx })); }))));
};
exports.default = TableHeader;
